<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBilling_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M1 4.429C1 3.639 1.627 3 2.4 3h11.2c.773 0 1.4.64 1.4 1.429v1.428H1V4.43ZM1 8h14v3.571c0 .79-.627 1.429-1.4 1.429H2.4c-.773 0-1.4-.64-1.4-1.429V8Z"
    />
</svg>
